export default __webpack_public_path__ + "static/media/flag.4d9d9906.png";